var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.$style.spinner,attrs:{"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('ellipse',{class:_vm.$style.spinnerEllipse,style:({
            stroke: _vm.stroke,
        }),attrs:{"cx":"12","cy":"12","rx":"10","ry":"10"}})])}
var staticRenderFns = []

export { render, staticRenderFns }